import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix leaflet marker icons issue in React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// List of cities with coordinates
const cities = [
  { name: "Mumbai", coords: [19.0760, 72.8777] },
  { name: "Thane", coords: [19.2183, 72.9781] },
  { name: "Nagpur", coords: [21.1458, 79.0882] },
  { name: "Nashik", coords: [19.9975, 73.7898] },
  { name: "Aurangabad", coords: [19.8762, 75.3433] },
  { name: "Shirdi", coords: [19.7666, 74.4774] },
  { name: "Indore", coords: [22.7196, 75.8577] },
  { name: "Bangalore", coords: [12.9716, 77.5946] },
  { name: "Chennai", coords: [13.0827, 80.2707] },
  { name: "Bhopal", coords: [23.2599, 77.4126] },
  { name: "New Delhi", coords: [28.6139, 77.2090] },
  { name: "South Delhi", coords: [28.4986, 77.2507] },
  { name: "Agra", coords: [27.1767, 78.0081] },
  { name: "Ahmedabad", coords: [23.0225, 72.5714] },
  { name: "Noida", coords: [28.5355, 77.3910] },
  { name: "Gurgaon", coords: [28.4595, 77.0266] },
  { name: "Puducherry", coords: [11.9416, 79.8083] },
  { name: "Shimla", coords: [31.1048, 77.1734] },
  { name: "Srinagar", coords: [34.0837, 74.7973] },
  { name: "Surat", coords: [21.1702, 72.8311] },
  { name: "Bhubaneswar", coords: [20.2961, 85.8245] },
  { name: "Faridabad", coords: [28.4089, 77.3178] },
  { name: "Hyderabad", coords: [17.3850, 78.4867] },
  { name: "Goa", coords: [15.2993, 74.1240] },
  { name: "Chandigarh", coords: [30.7333, 76.7794] },
  { name: "Coimbatore", coords: [11.0168, 76.9558] },
  { name: "Kolkata", coords: [22.5726, 88.3639] },
  { name: "Jamshedpur", coords: [22.8046, 86.2029] },
];

const CityMap = () => {
  return (
    <MapContainer center={[22.9734, 78.6569]} zoom={5} scrollWheelZoom={true}>
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {cities.map((city, index) => (
        <Marker key={index} position={city.coords}>
          <Popup>{city.name}</Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default CityMap;
